import { DocumentInfo } from "@/types/document";
import { InsightComponent } from "@/types/insights";
import { InsightsBarChartCard } from "./InsightsBarChartCard";
import { InsightsTable } from "./InsightsTable";
import { InsightsLineChartCard } from "./InsightsLineChartCard";
import { InsightsMetricCard } from "./InsightsMetricCard";
import { InsightsPieChartCard } from "./InsightsPieChartCard";

export const InsightsComponentRenderer = ({
  component,
  documentsById,
  flaggingByDocumentId,
  onFlagDocument,
}: {
  component: InsightComponent;
  documentsById: Map<string, DocumentInfo>;
  flaggingByDocumentId: Record<string, boolean>;
  onFlagDocument: (documentId: string) => Promise<void>;
}) => {
  switch (component.type) {
    case "metric":
      return <InsightsMetricCard component={component} />;
    case "line_chart":
      return <InsightsLineChartCard component={component} />;
    case "bar_chart":
      return <InsightsBarChartCard component={component} />;
    case "pie_chart":
      return <InsightsPieChartCard component={component} />;
    case "table":
      return (
        <InsightsTable
          component={component}
          documentsById={documentsById}
          flaggingByDocumentId={flaggingByDocumentId}
          onFlagDocument={onFlagDocument}
        />
      );
    default:
      return null;
  }
};
